import React from "react";

const Header = ({ selectedMedium, setSelectedMedium, HeadingText, SubHeadingText }) => {
    return (
        <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between">
            
            <div className="mb-4 md:mb-0">
                <h1 className="text-3xl font-bold">
                    {HeadingText}
                </h1>
                <p className="text-gray-600 text-sm">
                    {SubHeadingText}
                </p>
            </div>

            <div 
                // className="flex gap-3 md:justify-end justify-start w-full md:w-auto"
                className="flex gap-3 justify-center md:justify-end w-full md:w-auto"
            >
                <button
                    onClick={() => (selectedMedium === "English")?setSelectedMedium(""):setSelectedMedium("English")}
                    className={`px-6 py-2 text-sm rounded-lg border-2 ${selectedMedium === "English" ? "bg-[#2f2f2f] text-white border-[#2f2f2f]" : "bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-300"}`}
                >
                    English
                </button>
                <button
                    onClick={() => (selectedMedium === "Hindi")?setSelectedMedium(""):setSelectedMedium("Hindi")}
                    className={`px-6 py-2 text-sm rounded-lg border-2 ${selectedMedium === "Hindi" ? "bg-[#2f2f2f] text-white border-[#2f2f2f]" : "bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-300"}`}
                >
                    Hindi
                </button>
            </div>
        </div>

    );
};

export default Header;
